import { useState, useEffect } from 'react';
import { Calendar, dayjsLocalizer } from 'react-big-calendar';
import { getData, usuario, deleteData } from '../../resources';
import Loading from '../../loading'
import CreateCita, { CreateCitaForm } from './cita.create'
import { Button, Modal, Popconfirm, Card, Typography, Descriptions, Space, Tag } from 'antd'
import { CalendarOutlined, InfoCircleOutlined, UserOutlined, ClockCircleOutlined, MedicineBoxOutlined, FileTextOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons'
import dayjs from 'dayjs';
// import { GoogleOutlined } from '@ant-design/icons'
import AuthButton from './auth.button';
// import CitaGoogle from './cita.google';
// import '@dayjs/locale/es-mx';
// require('@dayjs/locale/es-mx');

const localizer = dayjsLocalizer(dayjs)

const { configuracion: { tratamientos_ofrecidos } = {} } = usuario || {};

// const today = new Date();

// To set rage for calendar
// start time 8:00am
// const min = new Date(
//     today.getFullYear(),
//     today.getMonth(),
//     today.getDate(),
//     8
// )

// end time 5:00pm
// const max = new Date(
//     today.getFullYear(),
//     today.getMonth(),
//     today.getDate(),
//     21
// )


export default function Citas() {

    const [isGoogleSincronized, setIsGoogleSincronized] = useState(false)

    const [citasData, setCitasData] = useState([])
    const [loading, setLoading] = useState(true)
    const [editingCita, setEditingCita] = useState(false)

    // Modal for details
    const [isModalOpen, setIsModalOpen] = useState(false)
    const showModal = () => { setIsModalOpen(true) }
    const handleOk = () => { setIsModalOpen(false); setEditingCita(false); setEditingCita(false) }
    const handleCancel = () => { setIsModalOpen(false); setEditingCita(false); setEditingCita(false) }
    // Modal for edit and create
    const [citaForEdit, setCitaForEdit] = useState(null)
    const [fecha_hora, setFecha_hora] = useState(null)
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)



    useEffect(() => { getCitasData() }, [])

    const getCitasData = () => {
        if (usuario)

            getData(`citas/medico/${usuario._id}`).then((rs) => {
                rs.forEach(cita => {

                    const servicio = cita.id_servicio;
                    const servicioInfo = tratamientos_ofrecidos?.find(servicioItem => servicioItem._id === servicio);
                    if (servicioInfo) {
                        cita.color = servicioInfo.color;
                    }

                    cita.start = new Date(Date.parse(cita.fecha_hora));
                    const endDate = new Date(cita.fecha_hora);
                    endDate.setTime(endDate.getTime() + 1 * (cita.duracion ?? 60) * 60 * 1000)
                    cita.end = new Date(Date.parse(endDate));
                    cita.title = cita.usuario && cita.usuario.name ? cita.usuario.name : new Date(Date.parse(cita.fecha_hora));
                    cita.id = cita._id;
                    cita.key = cita._id;
                });
                console.log('getCitasData medico', rs)
                setCitasData(rs)
            }
            ).finally(() => setLoading(false))
    }

    // Select cita to show details and to confirm
    const selectEvent = async (e) => {
        if (!e.hospital) e.hospital = e.sucursal._id; // For Edit
        if (e.sucursa && e.sucursal._id) e.sucursal = e.sucursal._id; // For Edit
        if (!e.paciente) e.paciente = e.usuario; // For details
        if (e.usuario && e.usuario._id) e.usuario = e.usuario._id; // For Editing
        e.fecha_hora = dayjs(e.fecha_hora) //For edit
        setCitaForEdit(e)
        showModal()
    }

    // Select time hour, where cita will be created 
    const handleSlotSelection = ({ start, end, action }) => {
        setFecha_hora(dayjs(start))
        setIsCreateModalOpen(true)
        return { style: { backgroundColor: 'red' } };
    };

    // Confirm servicio
    // const confirmService = () => {
    //     console.log('To confirm service', citaForEdit)
    //     updateData(`balances/update/cita/${citaForEdit._id}`, { estado: 'pagado' })
    // }

    // Delete button
    const confirm = (e) => {
        deleteData(`citas/remove/${citaForEdit._id}`).then((rs) => { console.log(rs); getCitasData(); handleCancel() })
        deleteData(`balances/remove/cita/${citaForEdit._id}`)

    };

    const cancel = (e) => { console.log(e) }

    const eventStyleGetter = (event, start, end, isSelected) => {
        // const index = serviceList.indexOf(event.servicio);
        // var backgroundColor = '#' + pre_colors[index]; 
        // var backgroundColor = '##03fc8c';
        var style = {
            backgroundColor: event.color || '#1677ff',
            borderRadius: '6px',
            opacity: 0.9,
            color: 'white',
            border: '0px',
            display: 'block',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            padding: '2px 4px',
            fontWeight: 500
        };
        return {
            style: style
        };
    }

    if (loading) return <Loading />;

    return <div className='mainContainer' style={{ padding: '24px', background: '#f5f7fa', minHeight: '100vh' }}>

        {/* <CitaGoogle />
        <br /> */}

        {/* <AuthButton setSincronized={setIsGoogleSincronized} /> WORKING */}

        {/* <Button icon={<GoogleOutlined />} >
            Sincronzar calendario
        </Button> */}

        <Card
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ padding: '8px', background: '#e6f4ff', borderRadius: '8px', display: 'flex' }}>
                        <CalendarOutlined style={{ fontSize: '22px', color: '#1677ff' }} />
                    </div>
                    <Typography.Title level={3} style={{ margin: 0, color: '#1f1f1f' }}>Agenda de Citas</Typography.Title>
                </div>
            }
            bordered={false}
            style={{ borderRadius: '16px', boxShadow: '0 4px 24px -8px rgba(0,0,0,0.05)' }}
        >
            <Calendar
                // min={min}
                // max={max}
                scrollToTime={new Date(Date.now())}
                defaultDate={new Date(Date.now())}
                selectable='true'
                localizer={localizer}
                events={citasData}
                eventPropGetter={eventStyleGetter}
                startAccessor="start"
                endAccessor="end"
                style={{ height: '70vh', minHeight: 600 }}
                messages={{
                    next: "Sig",
                    previous: "Ant",
                    today: "Hoy",
                    month: "Mes",
                    week: "Semana",
                    day: "Día",
                }}
                defaultView="week"
                onDoubleClickEvent={(e) => console.log(e)}
                onSelectEvent={selectEvent} // details cita
                onSelecting={(e) => console.log(e)}
                onSelectSlot={handleSlotSelection} // create cita
            />
        </Card>

        <Modal
            title={
                <Space>
                    <InfoCircleOutlined style={{ color: '#1677ff', fontSize: '20px' }} />
                    <span style={{ fontSize: '18px', fontWeight: 600 }}>Detalles de Cita</span>
                </Space>
            }
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            destroyOnClose
            centered
            width={600}
            footer={[
                <Popconfirm
                    key="delete"
                    title="Eliminar Cita"
                    description="¿Seguro que quiere eliminar la cita?"
                    onConfirm={confirm}
                    onCancel={cancel}
                    okText="Sí, eliminar"
                    cancelText="No"
                    okButtonProps={{ danger: true }}
                >
                    <Button danger icon={<DeleteOutlined />}>Eliminar</Button>
                </Popconfirm>,
                <Button key="edit" type={editingCita ? "default" : "primary"} onClick={() => setEditingCita(!editingCita)} icon={<EditOutlined />}>
                    {editingCita ? "Cancelar" : "Modificar"}
                </Button>,
                <Button key="close" onClick={handleCancel}>Cerrar</Button>
            ]}>
            {editingCita ?
                <CreateCitaForm isGoogleSincronized cita={citaForEdit} setIsModalOpen={setIsModalOpen} getCitasData={getCitasData} setEditingCita={setEditingCita} />
                : <div>{citaForEdit &&
                    <Descriptions column={1} bordered size="middle" labelStyle={{ fontWeight: '500', width: '160px', background: '#fafafa' }} style={{ marginTop: '16px' }}>
                        <Descriptions.Item label={<Space><UserOutlined /> Paciente</Space>}>
                            {citaForEdit.paciente ? <Typography.Text strong>{citaForEdit.paciente.name}</Typography.Text> : <Typography.Text type="secondary">Sin paciente</Typography.Text>}
                        </Descriptions.Item>
                        <Descriptions.Item label={<Space><CalendarOutlined /> Fecha</Space>}>
                            {new Date(citaForEdit.fecha_hora).toLocaleDateString()}
                        </Descriptions.Item>
                        <Descriptions.Item label={<Space><ClockCircleOutlined /> Hora</Space>}>
                            {new Date(citaForEdit.fecha_hora).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                        </Descriptions.Item>
                        <Descriptions.Item label={<Space><MedicineBoxOutlined /> Servicio</Space>}>
                            {citaForEdit.servicio ? <Tag color="blue">{citaForEdit.servicio}</Tag> : '-'}
                        </Descriptions.Item>
                        <Descriptions.Item label={<Space><FileTextOutlined /> Comentarios</Space>}>
                            {citaForEdit.comentarios || <Typography.Text type="secondary">Ninguno</Typography.Text>}
                        </Descriptions.Item>
                    </Descriptions>
                }
                </div>
            }
        </Modal>

        <CreateCita setIsModalOpen={setIsCreateModalOpen} isOpenModal={isCreateModalOpen} fecha_hora={fecha_hora} getCitasData={getCitasData} />

    </div>

}
